<!-- Power Bi Loader -->
<div class="page-loader d-flex align-items-center justify-content-center" *ngIf="isLoader">
    <img class="vsloader" style="width: 80px;" src="assets/images/loading.gif" alt="">
</div>
<div #visualOne style="width: 100%" [class.reportwithoutmap]="!this.itemId"></div>